import { string, oneOf } from 'prop-types';

const VariationsSubtitle = ({ className = '', text = '', as = 'p' }) => {
  const Element = as;
  return <Element className={className}>{text}</Element>;
};

VariationsSubtitle.propTypes = {
  className: string,
  text: string,
  as: oneOf(['p', 'span']),
};

export default VariationsSubtitle;
